<template>
  <v-card color="rgb(250, 250, 250)" class="elevation-0">
    <v-form ref="formulario" :disabled="guardando" @submit.prevent="guardar">
      <v-toolbar dense :color="colorBarraFormulario" dark flat>
        <v-toolbar-title>{{ accion === 'crear' ? 'Nueva pregunta' : 'Editar pregunta' }}</v-toolbar-title>
        <v-spacer />
        <v-btn small depressed :color="colorAccent1" class="mr-3 white--text" :loading="guardando" :disabled="guardando" type="submit">Guardar</v-btn>
        <v-btn icon :disabled="guardando" aria-label="Cerrar formulario de pregunta" @click="cerrar">
          <v-icon>mdi-close-circle</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pt-5">
        <v-alert v-if="error" type="error" outlined role="alert">{{ error }}</v-alert>
        <v-row dense align="center">
          <v-col cols="12" md="4">
            <v-text-field :value="categoriaNombre" label="Categoría" outlined dense readonly :dark="dark" :error-messages="errores.categoria_proveedor_id" />
          </v-col>
          <v-col cols="12" sm="4" md="2">
            <v-text-field v-model="formulario.orden" label="Orden" type="number" min="0" max="65535" step="1" outlined dense :dark="dark" :rules="[ordenValido]" :error-messages="errores.orden" />
          </v-col>
          <v-col cols="6" sm="4" md="3">
            <v-switch v-model="formulario.activa" label="Pregunta activa" class="mt-0" :dark="dark" :error-messages="errores.activa" />
          </v-col>
          <v-col cols="6" sm="4" md="3">
            <v-switch v-model="formulario.permite_comentario" label="Permitir comentarios" class="mt-0" :dark="dark" :error-messages="errores.permite_comentario" />
          </v-col>
        </v-row>
        <v-row dense>
          <v-col v-for="idioma in idiomas" :key="idioma.value" cols="12" md="4">
            <div class="subtitle-1 font-weight-medium mb-3">{{ idioma.text }}</div>
            <v-text-field
              v-model="formulario['titulo_' + idioma.value]"
              :label="'Título (' + idioma.value + ')'" outlined dense :dark="dark" maxlength="255"
              :rules="[obligatorio]" :error-messages="errores['titulo_' + idioma.value]"
            />
            <v-textarea
              v-model="formulario['pregunta_' + idioma.value]"
              :label="'Pregunta (' + idioma.value + ')'" outlined dense :dark="dark" rows="4" maxlength="5000"
              :rules="[obligatorio]" :error-messages="errores['pregunta_' + idioma.value]"
            />
            <v-textarea
              v-model="formulario['pregunta_comentario_' + idioma.value]"
              :label="'Texto del comentario (' + idioma.value + ') · Opcional'" outlined dense :dark="dark" rows="3" maxlength="5000"
              :disabled="!formulario.permite_comentario" :error-messages="errores['pregunta_comentario_' + idioma.value]"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="px-4 pb-4">
        <v-spacer />
        <v-btn text :disabled="guardando" @click="cerrar">Cancelar</v-btn>
        <v-btn depressed :color="colorAccent1" class="white--text" :loading="guardando" :disabled="guardando" type="submit">Guardar</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import { mapState } from 'vuex';
import { crearPreguntaValoracion, editarPreguntaValoracion } from '@/services/valoraciones';

export default {
  name: 'ValoracionPreguntaFormulario',
  props: {
    modelPregunta: { type: Object, required: true },
    categoriaNombre: { type: String, required: true },
    accion: { type: String, required: true },
  },
  data() {
    const formulario = {
      orden: 0,
      activa: true,
      permite_comentario: true,
      ...this.modelPregunta,
    };
    const idiomas = [
      { text: 'Español', value: 'ES' },
      { text: 'English', value: 'EN' },
      { text: 'Deutsch', value: 'DE' },
    ];
    idiomas.forEach(idioma => {
      ['titulo', 'pregunta', 'pregunta_comentario'].forEach(campo => {
        const clave = campo + '_' + idioma.value;
        formulario[clave] = formulario[clave] || '';
      });
    });
    return { formulario, idiomas, guardando: false, errores: {}, error: '' };
  },
  computed: {
    ...mapState(['dark', 'colorBarraFormulario', 'colorAccent1']),
    ...mapState('auth', ['access_token']),
  },
  methods: {
    obligatorio(valor) {
      return !!String(valor || '').trim() || 'Este campo es obligatorio.';
    },
    ordenValido(valor) {
      return (String(valor).trim() !== '' && Number.isInteger(Number(valor)) && Number(valor) >= 0 && Number(valor) <= 65535)
        || 'Introduce un número entero entre 0 y 65535.';
    },
    cerrar() {
      if (!this.guardando) this.$emit('cerrarFormularioPregunta');
    },
    async guardar() {
      if (this.guardando) return;
      this.errores = {};
      this.error = '';
      if (!this.$refs.formulario.validate()) return;
      const datos = {
        orden: Number(this.formulario.orden),
        activa: this.formulario.activa,
        permite_comentario: this.formulario.permite_comentario,
      };
      this.idiomas.forEach(idioma => {
        ['titulo', 'pregunta', 'pregunta_comentario'].forEach(campo => {
          const clave = campo + '_' + idioma.value;
          datos[clave] = this.formulario[clave].trim() || null;
        });
      });
      this.guardando = true;
      try {
        let pregunta;
        if (this.accion === 'crear') {
          datos.categoria_proveedor_id = this.modelPregunta.categoria_proveedor_id;
          pregunta = await crearPreguntaValoracion(this.access_token, datos);
        } else {
          pregunta = await editarPreguntaValoracion(this.access_token, this.modelPregunta.id, datos);
        }
        this.$emit('preguntaGuardada', pregunta);
      } catch (error) {
        const respuesta = error.response;
        this.errores = respuesta && respuesta.data && respuesta.data.errors || {};
        this.error = respuesta && respuesta.status === 422
          ? 'Revisa los campos indicados.'
          : 'No se pudo guardar la pregunta. Inténtalo de nuevo.';
      } finally {
        this.guardando = false;
      }
    },
  },
};
</script>
